module.exports = __webpack_public_path__ + "static/media/forest.5d861804.svg";